import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/analytics';

import config from './firebaseConfig';

const app = firebase.initializeApp(config);
const analytics = firebase.analytics();
// eslint-disable-next-line
if (location.hostname === 'localhost') {
  firebase.functions()
    .useFunctionsEmulator('http://localhost:5001');
}

const auth = firebase.auth();

const db = firebase.firestore();

const functions = firebase.functions();

export default app;

export {
  app,
  analytics,
  firebase,
  db,
  auth,
  functions,
};
